<template>
  <article
    class="c-card-speciality-player position-relative d-block
      br--medium overflow-hidden"
    :class="{'completed' : specStatus.type === 3}"
  >
    <figure class="c-card-speciality-player__cover">
      <img :src="body.cover" class="w-100 of--cover" alt="">
    </figure>

    <div class="c-card-speciality-player__actions">
      <button v-if="false" class="c-link c-link--white me-2">
        <div class="iconf-star"></div>
      </button>

      <Dropdown v-model="switcher" class="c-more-actions">
        <template v-slot:toggle>
          <button @click="switcher = !switcher" class="c-more-actions__button">
            <div class="d-flex">
              <Icon icon="uiw:setting" class="fs-18 me-1" />
              <Icon icon="ant-design:caret-down-filled" class="fs-18" />
            </div>
          </button>
        </template>
        <template v-slot:menu>
          <ul>
            <li>
              <button
                @click="hide()"
                :disabled="isLoading"
                class="c-more-actions__item d-flex"
              >
                <Icon :icon="hideButton.icon" class="fs-18 me-2" />
                <span class="fs-14 w-sbold">{{ hideButton.label }}</span>
              </button>
            </li>
            <li v-if="!hasFullAccess" color="alert">
              <button
                @click="unenroll()"
                :disabled="isLoading"
                class="c-more-actions__item d-flex"
              >
                <Icon icon="ci:trash-full" class="fs-18 me-2" />
                <span class="fs-14 w-sbold">Eliminar</span>
              </button>
            </li>
          </ul>
        </template>
      </Dropdown>
    </div>

    <div class="c-card-speciality-player__body position-absolute w-100 h-100 d-flex
      flex-column justify-content-end p-4 text-start"
    >
      <div class="d-flex mb-3 align-items-start">
        <h4 class="c-card-speciality-player__title fs-18 w-bold mb-3">
          <a :href="body.url">{{body.title}}</a>
        </h4>
        <div class="ps-3">
          <div class="c-card-speciality-player__badge rounded
            d-flex justify-content-center align-items-center">
            <i class="iconf-medal fs-21"></i>
          </div>
        </div>
      </div>

      <div>
        <p
          v-if="specStatus.type === 1 || specStatus.type === 2"
          class="fs-14 pri-alt w-sbold mb-0"
        >
          {{specStatus.description}}
        </p>

        <div v-if="specStatus.type === 3" class="d-flex align-items-center">
          <div class="c-card-course-player__ok rounded bg-pri-color white d-flex
            justify-content-center align-items-center">
            <i class="iconf-ok d-flex align-items-center"></i>
          </div>
          <span class="ms-2 fs-14 w-medium white">Especialidad completada</span>
        </div>

        <Progress
          v-if="specStatus.type === 2 || specStatus.type === 3"
          class="mt-1"
          :percentage="body.progress.percentage"
          :isSingle="true" />

        <router-link
          :to="specLink"
          class="c-button medium d-flex justify-content-center align-items-center mt-4"
          :class="(body.percentage) ? 'c-button--white' : 'c-button--primary'"
        >
          <i class="iconf-right-arrow me-2"></i>
          Ver cursos
        </router-link>
      </div>
    </div>
  </article>
</template>

<script>
import { Icon } from '@iconify/vue2';

export default {
  data() {
    return {
      switcher: false,

      isLoading: false,
    };
  },
  props: ['body', 'user', 'list', 'total', 'empty'],
  components: {
    Icon,
    Progress: () => import(/* webpackChunkName: "progress-bar" */'../ProgressBar.vue'),
    Dropdown: () => import(/* webpackChunkName: "dropdown" */'../ui/Dropdown.vue'),
  },
  computed: {
    specStatus() {
      let status = { label: '', type: -1 };

      if (this.body.progress) {
        const percentage = Number(this.body.progress.percentage);
        if (percentage === 0) {
          status = {
            type: 1,
            description: `${this.body.progress.advance}/${this.body.progress.total} cursos completados`,
          };
        } else if (percentage >= 100) {
          status = {
            type: 3,
          };
        } else {
          status = {
            type: 2,
            description: `${this.body.progress.advance}/${this.body.progress.total} cursos completados`,
          };
        }
      }

      return status;
    },
    specLink() {
      return `/especialidad/${this.body.id}`;
    },

    hideButton() {
      return {
        label: (this.$route.query.type && this.$route.query.type === 'hide') ? 'Mostrar' : 'Ocultar',
        icon: (this.$route.query.type && this.$route.query.type === 'hide') ? 'bi:eye-fill' : 'bi:eye-slash-fill',
      };
    },
    hasFullAccess() {
      return this.body.access && this.body.access.plan === 'vitalicio';
    },
  },
  methods: {
    getProductREST(operation) {
      return `${window.arcux.api}/profile/${this.user.id}/products/${this.body.id}/${operation}`;
    },

    hide() {
      const request = this.getProductREST('hide');

      this.isLoading = true;

      fetch(request, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then((res) => {
          if (res.status === 200 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.updateData();
          }

          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    unenroll() {
      const request = this.getProductREST('remove');

      this.isLoading = true;

      fetch(request, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
        .then(() => {
          this.updateData();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    updateData() {
      const newList = this.list.filter((co) => co !== this.body);

      this.switcher = false;

      this.$emit('update:list', newList);
      this.$emit('update:total', this.total - 1);
      this.$emit('update:empty', !newList.length);
    },
  },
};
</script>
